export function clearMap(map: google.maps.Map): void {
  return map.data.forEach(feature => map.data.remove(feature));
}

export default clearMap;
